(function () {
    directlyToCheckoutEdit.$inject = ["$scope", "product", "$uibModalInstance"];
    angular.module('dnecom').controller('DirectlyToCheckoutEditController', directlyToCheckoutEdit);

    function directlyToCheckoutEdit($scope, product, $uibModalInstance) {
        $scope.model = product.directlyToCheckoutSettings;
        $scope.availableNumberOfSteps = [1, 2];
        $scope.fonts = [
            'Arial',
            'Lato',
            'Helvetica',
            'Open Sans',
            'Montserrat',
            'Roboto',
            'Source Sans Pro',
            'Tahoma',
            'Verdana'
        ];

        $scope.submit = submit;

        function submit() {
            product.directlyToCheckoutSettings = $scope.model ? angular.copy($scope.model): null;
            $uibModalInstance.close();
        }
    }
})();
